import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import debounce from 'lodash/debounce';
import each from 'lodash/each';
import flattenDeep from 'lodash/flattenDeep';

export const _ = {
  get,
  keyBy,
  debounce,
  each,
  flattenDeep
};
